import React, {useState, useEffect, useContext} from "react";
import { Button } from "../ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Notification } from "@/src/models/notification_model";
import { getNotifications, updateNotification } from "../../api/notification_api";
import { NotificationIconBell } from "../ui/icons/NotificationIconBell";
import { useNavigate } from "react-router-dom";
// import {CompanyType} from "@models/company";
import {UserContext} from "../../contexts/UserContext";
import {CompanyType} from "../../models/company";
import { time } from "console";


interface NotificationIconProps {
    accessToken: string;
}

const NotificationHeader = ({ accessToken }: NotificationIconProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [loading, setLoading] = useState(true);
    const [unreadNotification, setUnreadNotification] = useState<number | null>(null)
    const userContext = useContext(UserContext);
    const navigate = useNavigate();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const unreadNotificationCounter = () => {
        const updatedNotification = notifications.filter((item) => item.is_read === false)
        setUnreadNotification(updatedNotification.length)
    }

    useEffect(() => {
        const fetchNotifications = async (token: string) => {
            try {
                const data = await getNotifications(token);
                setNotifications(data);
            } catch (error) {
                console.error("Error fetching notifications", error);
            } finally {
                setLoading(false);

            }
        };

        if(userContext?.company_type !== CompanyType.not_set) {
            fetchNotifications(accessToken);

            const intervalId = setInterval(()=> {
                fetchNotifications(accessToken)
            }, 300000)

            return () => clearInterval(intervalId)
        }
        
    }, [accessToken]);

    useEffect(() => {
        unreadNotificationCounter();
    }, [notifications]);

    if (loading) {
        // Note - no need to do anything here.
        // if the user is not a company member they dont have notifications.
        return <></>;
    }
    

    const handleGoTo = async (url: string, index: number, is_read: boolean, notificationId:string) => {
        navigate(`/${url}`);
        
        if (!is_read) {
            const notificationToUpdate = notifications[index];
            if (notificationToUpdate) {
                const updatedNotification = { ...notificationToUpdate, is_read: true };
                console.log('data before update', updatedNotification)
                try {
                    await updateNotification(accessToken, notificationId, updatedNotification)
                    setNotifications((prevNotifications) =>
                        prevNotifications.map((notification, i) =>
                            i === index ? updatedNotification : notification
                        )
                    );
                }catch(err) {
                    console.log(err)
                }
            }
        }

    };

    return (
        <DropdownMenu>
            
            <DropdownMenuTrigger asChild className="m-7">
            <div className="flex flex-col items-center">
            {unreadNotification && (
                        <p className="text-sm font-bold cursor-pointer text-green-900">#{unreadNotification}</p>
                    )}
                <button onClick={toggleMenu} className="relative">
                    <NotificationIconBell />
                </button>
            </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="end"
                className="w-72 max-h-96 overflow-y-auto bg-white border border-gray-200 rounded-xl shadow-xl p-4"
                style={{ borderRadius: "20px" }}
            >
                {notifications.length === 0 ? (
                    <DropdownMenuItem className="text-center text-gray-500">
                        No new notifications
                    </DropdownMenuItem>
                ) : (
                    notifications.map((notification, index) => (
                        <DropdownMenuItem
                            key={notification._id}
                            className={`p-4 mb-2 rounded-lg border-b border-gray-100
                                ${notification.is_read ? 'bg-gray-100 text-gray-400 opacity-50' : 'bg-gray-100 text-gray-800 opacity-100'}
                            `}
                        >
                            <div className="flex justify-between items-start w-full">
                                <div>
                                    <p className="text-sm font-semibold text-gray-700 overflow-hidden">
                                        {notification.notification[0].tool} : {notification.notification[0].message}
                                    </p>
                                    <small className="text-xs text-gray-400 block mt-1">
                                        {new Date(
                                            notification.notification[0].created_at
                                        ).toLocaleString()}
                                    </small>
                                </div>
                                <button
                                    className="text-blue-500 text-xs hover:underline"
                                    onClick={() =>
                                        handleGoTo(
                                            notification.notification[0].url,
                                            index,
                                            notification.is_read,
                                            notification.notification_id                                       )
                                    }
                                >
                                    Go to
                                </button>
                            </div>
                        </DropdownMenuItem>
                    ))
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default NotificationHeader;
